const isVideo = (src: string) => {
  if (['mp4', 'mov'].includes(src.split('.')[src.split('.').length - 1])) {
    return true;
  } else {
    return false;
  }
};

export default isVideo;
